import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=46460d2a&scoped=true&lang=pug&"
import script from "./notification.vue?vue&type=script&lang=ts&"
export * from "./notification.vue?vue&type=script&lang=ts&"
import style0 from "./notification.vue?vue&type=style&index=0&id=46460d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46460d2a",
  null
  
)

export default component.exports